import React from "react";

const CustomInput = ({ type, label, id, value, onChange }) => (
  <div className="form-group">
    <label htmlFor={id}>{label}</label>
    <input
      type={type}
      className="form-control"
      id={id}
      value={value}
      onChange={onChange}
    />
  </div>
);

export default CustomInput;
